import * as React from 'react';
import styled from 'styled-components';
import { FilterMenu } from './FilterMenu';
import { GoalSelector } from './GoalSelector';
import { mediaMinWidth } from '../sharedStyle/mediaQueries';
import { Tooltip } from 'react-tippy';
import 'react-tippy/dist/tippy.css';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  ${mediaMinWidth(24)};
  height: 56px;
  margin: 0 auto 16px 5%;
`;

const Divider = styled.div`
  padding: 0 4px;
`;

export class AppToolbar extends React.PureComponent<{}, {}> {
  public render() {
    return (
      <Wrapper>
        <Tooltip title={'ゴール'} distance={4}>
          <GoalSelector />
        </Tooltip>
        <Divider />
        <Tooltip title={'絞り込み'} distance={4}>
          <FilterMenu />
        </Tooltip>
      </Wrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/presentation/component/AppToolbar.tsx